import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { isWebKit, clamp } from '@react-aria/utils';

var AXIS = {
  top: 'top',
  bottom: 'top',
  left: 'left',
  right: 'left'
};
var FLIPPED_DIRECTION = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};
var CROSS_AXIS = {
  top: 'left',
  left: 'top'
};
var AXIS_SIZE = {
  top: 'height',
  left: 'width'
};
var TOTAL_SIZE = {
  width: 'totalWidth',
  height: 'totalHeight'
};
var PARSED_PLACEMENT_CACHE = {};

// @ts-ignore
var visualViewport = typeof document !== 'undefined' && window.visualViewport;
function getContainerDimensions(containerNode) {
  var width = 0,
    height = 0,
    totalWidth = 0,
    totalHeight = 0,
    top = 0,
    left = 0;
  var scroll = {};
  //@ts-expect-error
  var isPinchZoomedIn = (visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.scale) > 1;
  if (containerNode.tagName === 'BODY') {
    var _visualViewport$width, _visualViewport$heigh;
    var documentElement = document.documentElement;
    totalWidth = documentElement.clientWidth;
    totalHeight = documentElement.clientHeight;
    //@ts-expect-error
    width = (_visualViewport$width = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.width) !== null && _visualViewport$width !== void 0 ? _visualViewport$width : totalWidth;
    //@ts-expect-error
    height = (_visualViewport$heigh = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.height) !== null && _visualViewport$heigh !== void 0 ? _visualViewport$heigh : totalHeight;
    scroll.top = documentElement.scrollTop || containerNode.scrollTop;
    scroll.left = documentElement.scrollLeft || containerNode.scrollLeft;

    // The goal of the below is to get a top/left value that represents the top/left of the visual viewport with
    // respect to the layout viewport origin. This combined with the scrollTop/scrollLeft will allow us to calculate
    // coordinates/values with respect to the visual viewport or with respect to the layout viewport.
    if (visualViewport) {
      top = visualViewport.offsetTop;
      left = visualViewport.offsetLeft;
    }
  } else {
    var _getOffset = getOffset(containerNode);
    width = _getOffset.width;
    height = _getOffset.height;
    top = _getOffset.top;
    left = _getOffset.left;
    scroll.top = containerNode.scrollTop;
    scroll.left = containerNode.scrollLeft;
    totalWidth = width;
    totalHeight = height;
  }
  if (isWebKit() && (containerNode.tagName === 'BODY' || containerNode.tagName === 'HTML') && isPinchZoomedIn) {
    // Safari will report a non-zero scrollTop/Left for the non-scrolling body/HTML element when pinch zoomed in unlike other browsers.
    // Set to zero for parity calculations so we get consistent positioning of overlays across all browsers.
    // Also switch to visualViewport.pageTop/pageLeft so that we still accomodate for scroll positioning for body/HTML elements that are actually scrollable
    // before pinch zoom happens
    scroll.top = 0;
    scroll.left = 0;
    //@ts-expect-error
    top = visualViewport.pageTop;
    //@ts-expect-error
    left = visualViewport.pageLeft;
  }
  return {
    width: width,
    height: height,
    totalWidth: totalWidth,
    totalHeight: totalHeight,
    scroll: scroll,
    top: top,
    left: left
  };
}
function getScroll(node) {
  return {
    top: node.scrollTop,
    left: node.scrollLeft,
    width: node.scrollWidth,
    height: node.scrollHeight
  };
}

// Determines the amount of space required when moving the overlay to ensure it remains in the boundary
function getDelta(axis, offset, size,
// The dimensions of the boundary element that the popover is
// positioned within (most of the time this is the <body>).
boundaryDimensions,
// The dimensions of the containing block element that the popover is
// positioned relative to (e.g. parent with position: relative).
// Usually this is the same as the boundary element, but if the popover
// is portaled somewhere other than the body and has an ancestor with
// position: relative/absolute, it will be different.
containerDimensions, padding, containerOffsetWithBoundary) {
  var containerScroll = containerDimensions.scroll[axis];
  // The height/width of the boundary. Matches the axis along which we are adjusting the overlay position
  //@ts-expect-error
  var boundarySize = boundaryDimensions[AXIS_SIZE[axis]];
  // Calculate the edges of the boundary (accomodating for the boundary padding) and the edges of the overlay.
  // Note that these values are with respect to the visual viewport (aka 0,0 is the top left of the viewport)
  //@ts-expect-error
  var boundaryStartEdge = boundaryDimensions.scroll[AXIS[axis]] + padding;
  var boundaryEndEdge =
  //@ts-expect-error
  boundarySize + boundaryDimensions.scroll[AXIS[axis]] - padding;
  var startEdgeOffset = offset -
  //@ts-expect-error
  containerScroll +
  //@ts-expect-error
  containerOffsetWithBoundary[axis] -
  //@ts-expect-error
  boundaryDimensions[AXIS[axis]];
  var endEdgeOffset = offset -
  //@ts-expect-error
  containerScroll + size +
  //@ts-expect-error
  containerOffsetWithBoundary[axis] -
  //@ts-expect-error
  boundaryDimensions[AXIS[axis]];

  // If any of the overlay edges falls outside of the boundary, shift the overlay the required amount to align one of the overlay's
  // edges with the closest boundary edge.
  if (startEdgeOffset < boundaryStartEdge) {
    return boundaryStartEdge - startEdgeOffset;
  } else if (endEdgeOffset > boundaryEndEdge) {
    return Math.max(boundaryEndEdge - endEdgeOffset, boundaryStartEdge - startEdgeOffset);
  } else {
    return 0;
  }
}
function getMargins(node) {
  var style = window.getComputedStyle(node);
  return {
    top: parseInt(style.marginTop, 10) || 0,
    bottom: parseInt(style.marginBottom, 10) || 0,
    left: parseInt(style.marginLeft, 10) || 0,
    right: parseInt(style.marginRight, 10) || 0
  };
}
function parsePlacement(input) {
  //@ts-expect-error
  if (PARSED_PLACEMENT_CACHE[input]) {
    //@ts-expect-error
    return PARSED_PLACEMENT_CACHE[input];
  }

  // eslint-disable-next-line prefer-const
  var _input$split = input.split(' '),
    _input$split2 = _slicedToArray(_input$split, 2),
    placement = _input$split2[0],
    crossPlacement = _input$split2[1];
  //@ts-expect-error
  var axis = AXIS[placement] || 'right';
  //@ts-expect-error
  var crossAxis = CROSS_AXIS[axis];

  //@ts-expect-error
  if (!AXIS[crossPlacement]) {
    crossPlacement = 'center';
  }

  //@ts-expect-error
  var size = AXIS_SIZE[axis];
  //@ts-expect-error
  var crossSize = AXIS_SIZE[crossAxis];
  //@ts-expect-error
  PARSED_PLACEMENT_CACHE[input] = {
    placement: placement,
    crossPlacement: crossPlacement,
    axis: axis,
    crossAxis: crossAxis,
    size: size,
    crossSize: crossSize
  };
  //@ts-expect-error
  return PARSED_PLACEMENT_CACHE[input];
}
function computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset) {
  var placement = placementInfo.placement,
    crossPlacement = placementInfo.crossPlacement,
    axis = placementInfo.axis,
    crossAxis = placementInfo.crossAxis,
    size = placementInfo.size,
    crossSize = placementInfo.crossSize;
  var position = {};

  // button position
  //@ts-expect-error
  position[crossAxis] = childOffset[crossAxis];
  if (crossPlacement === 'center') {
    //  + (button size / 2) - (overlay size / 2)
    // at this point the overlay center should match the button center
    //@ts-expect-error
    position[crossAxis] += (childOffset[crossSize] - overlaySize[crossSize]) / 2;
  } else if (crossPlacement !== crossAxis) {
    //  + (button size) - (overlay size)
    // at this point the overlay bottom should match the button bottom
    //@ts-expect-error
    position[crossAxis] += childOffset[crossSize] - overlaySize[crossSize];
  } /* else {
    the overlay top should match the button top
    } */

  //@ts-expect-error
  position[crossAxis] += crossOffset;

  // overlay top overlapping arrow with button bottom
  var minPosition =
  //@ts-expect-error
  childOffset[crossAxis] - overlaySize[crossSize] + arrowSize + arrowBoundaryOffset;
  // overlay bottom overlapping arrow with button top
  var maxPosition =
  //@ts-expect-error
  childOffset[crossAxis] + childOffset[crossSize] - arrowSize - arrowBoundaryOffset;
  //@ts-expect-error
  position[crossAxis] = clamp(position[crossAxis], minPosition, maxPosition);

  // Floor these so the position isn't placed on a partial pixel, only whole pixels. Shouldn't matter if it was floored or ceiled, so chose one.
  if (placement === axis) {
    // If the container is positioned (non-static), then we use the container's actual
    // height, as `bottom` will be relative to this height.  But if the container is static,
    // then it can only be the `document.body`, and `bottom` will be relative to _its_
    // container, which should be as large as boundaryDimensions.
    var containerHeight = isContainerPositioned ? containerOffsetWithBoundary[size] :
    //@ts-expect-error
    boundaryDimensions[TOTAL_SIZE[size]];
    //@ts-expect-error
    position[FLIPPED_DIRECTION[axis]] = Math.floor(
    //@ts-expect-error
    containerHeight - childOffset[axis] + offset);
  } else {
    //@ts-expect-error
    position[axis] = Math.floor(childOffset[axis] + childOffset[size] + offset);
  }
  return position;
}
function getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlayHeight, heightGrowthDirection) {
  var containerHeight = isContainerPositioned ? containerOffsetWithBoundary.height :
  //@ts-expect-error
  boundaryDimensions[TOTAL_SIZE.height];
  // For cases where position is set via "bottom" instead of "top", we need to calculate the true overlay top with respect to the boundary. Reverse calculate this with the same method
  // used in computePosition.
  var overlayTop = position.top != null ? containerOffsetWithBoundary.top + position.top : containerOffsetWithBoundary.top + (
  //@ts-expect-error
  containerHeight - position.bottom - overlayHeight);
  var maxHeight = heightGrowthDirection !== 'top' ?
  // We want the distance between the top of the overlay to the bottom of the boundary
  Math.max(0, boundaryDimensions.height + boundaryDimensions.top +
  //@ts-expect-error
  boundaryDimensions.scroll.top -
  // this is the bottom of the boundary
  overlayTop - (
  // this is the top of the overlay
  //@ts-expect-error
  margins.top + margins.bottom + padding) // save additional space for margin and padding
  ) :
  // We want the distance between the bottom of the overlay to the top of the boundary
  Math.max(0, overlayTop + overlayHeight - (
  // this is the bottom of the overlay
  //@ts-expect-error
  boundaryDimensions.top + boundaryDimensions.scroll.top) - (
  // this is the top of the boundary
  //@ts-expect-error
  margins.top + margins.bottom + padding) // save additional space for margin and padding
  );
  return Math.min(boundaryDimensions.height - padding * 2, maxHeight);
}
function getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding, placementInfo) {
  var placement = placementInfo.placement,
    axis = placementInfo.axis,
    size = placementInfo.size;
  if (placement === axis) {
    return Math.max(0,
    //@ts-expect-error
    childOffset[axis] -
    //@ts-expect-error
    boundaryDimensions[axis] -
    //@ts-expect-error
    boundaryDimensions.scroll[axis] +
    //@ts-expect-error
    containerOffsetWithBoundary[axis] -
    //@ts-expect-error
    margins[axis] -
    //@ts-expect-error
    margins[FLIPPED_DIRECTION[axis]] - padding);
  }
  return Math.max(0, boundaryDimensions[size] +
  //@ts-expect-error
  boundaryDimensions[axis] + boundaryDimensions.scroll[axis] -
  //@ts-expect-error
  containerOffsetWithBoundary[axis] -
  //@ts-expect-error
  childOffset[axis] - childOffset[size] -
  //@ts-expect-error
  margins[axis] -
  //@ts-expect-error
  margins[FLIPPED_DIRECTION[axis]] - padding);
}
function calculatePositionInternal(placementInput, childOffset, overlaySize, scrollSize, margins, padding, flip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, userSetMaxHeight, arrowSize, arrowBoundaryOffset) {
  var placementInfo = parsePlacement(placementInput);
  var _placementInfo = placementInfo,
    size = _placementInfo.size,
    crossAxis = _placementInfo.crossAxis,
    crossSize = _placementInfo.crossSize,
    placement = _placementInfo.placement,
    crossPlacement = _placementInfo.crossPlacement;
  var position = computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
  var normalizedOffset = offset;
  var space = getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, placementInfo);

  // Check if the scroll size of the overlay is greater than the available space to determine if we need to flip
  if (flip && scrollSize[size] > space) {
    var flippedPlacementInfo = parsePlacement( //@ts-expect-error
    "".concat(FLIPPED_DIRECTION[placement], " ").concat(crossPlacement));
    var flippedPosition = computePosition(childOffset, boundaryDimensions, overlaySize, flippedPlacementInfo, offset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
    var flippedSpace = getAvailableSpace(boundaryDimensions, containerOffsetWithBoundary, childOffset, margins, padding + offset, flippedPlacementInfo);

    // If the available space for the flipped position is greater than the original available space, flip.
    if (flippedSpace > space) {
      placementInfo = flippedPlacementInfo;
      position = flippedPosition;
      normalizedOffset = offset;
    }
  }

  // Determine the direction the height of the overlay can grow so that we can choose how to calculate the max height
  var heightGrowthDirection = 'bottom';
  if (placementInfo.axis === 'top') {
    if (placementInfo.placement === 'top') {
      heightGrowthDirection = 'top';
    } else if (placementInfo.placement === 'bottom') {
      heightGrowthDirection = 'bottom';
    }
  } else if (placementInfo.crossAxis === 'top') {
    if (placementInfo.crossPlacement === 'top') {
      heightGrowthDirection = 'bottom';
    } else if (placementInfo.crossPlacement === 'bottom') {
      heightGrowthDirection = 'top';
    }
  }
  var delta = getDelta(crossAxis,
  //@ts-expect-error
  position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
  //@ts-expect-error
  position[crossAxis] += delta;
  var maxHeight = getMaxHeight(position, boundaryDimensions, containerOffsetWithBoundary, isContainerPositioned, margins, padding, overlaySize.height, heightGrowthDirection);
  if (userSetMaxHeight && userSetMaxHeight < maxHeight) {
    maxHeight = userSetMaxHeight;
  }
  overlaySize.height = Math.min(overlaySize.height, maxHeight);
  position = computePosition(childOffset, boundaryDimensions, overlaySize, placementInfo, normalizedOffset, crossOffset, containerOffsetWithBoundary, isContainerPositioned, arrowSize, arrowBoundaryOffset);
  delta = getDelta(crossAxis,
  //@ts-expect-error
  position[crossAxis], overlaySize[crossSize], boundaryDimensions, containerDimensions, padding, containerOffsetWithBoundary);
  //@ts-expect-error
  position[crossAxis] += delta;
  var arrowPosition = {};

  // All values are transformed so that 0 is at the top/left of the overlay depending on the orientation
  // Prefer the arrow being in the center of the trigger/overlay anchor element
  var preferredArrowPosition =
  //@ts-expect-error
  childOffset[crossAxis] + 0.5 * childOffset[crossSize] - position[crossAxis];

  // Min/Max position limits for the arrow with respect to the overlay
  var arrowMinPosition = arrowSize / 2 + arrowBoundaryOffset;
  var arrowMaxPosition = overlaySize[crossSize] - arrowSize / 2 - arrowBoundaryOffset;

  // Min/Max position limits for the arrow with respect to the trigger/overlay anchor element
  var arrowOverlappingChildMinEdge =
  //@ts-expect-error
  childOffset[crossAxis] - position[crossAxis] + arrowSize / 2;
  var arrowOverlappingChildMaxEdge =
  //@ts-expect-error
  childOffset[crossAxis] + childOffset[crossSize] -
  //@ts-expect-error
  position[crossAxis] - arrowSize / 2;

  // Clamp the arrow positioning so that it always is within the bounds of the anchor and the overlay
  var arrowPositionOverlappingChild = clamp(preferredArrowPosition, arrowOverlappingChildMinEdge, arrowOverlappingChildMaxEdge);
  arrowPosition[crossAxis] = clamp(arrowPositionOverlappingChild, arrowMinPosition, arrowMaxPosition);
  return {
    position: position,
    maxHeight: maxHeight,
    arrowOffsetLeft: arrowPosition.left,
    arrowOffsetTop: arrowPosition.top,
    placement: placementInfo.placement
  };
}

/**
 * Determines where to place the overlay with regards to the target and the position of an optional indicator.
 */
function calculatePosition(opts) {
  var placement = opts.placement,
    targetNode = opts.targetNode,
    overlayNode = opts.overlayNode,
    scrollNode = opts.scrollNode,
    padding = opts.padding,
    shouldFlip = opts.shouldFlip,
    boundaryElement = opts.boundaryElement,
    offset = opts.offset,
    crossOffset = opts.crossOffset,
    maxHeight = opts.maxHeight,
    _opts$arrowSize = opts.arrowSize,
    arrowSize = _opts$arrowSize === void 0 ? 0 : _opts$arrowSize,
    _opts$arrowBoundaryOf = opts.arrowBoundaryOffset,
    arrowBoundaryOffset = _opts$arrowBoundaryOf === void 0 ? 0 : _opts$arrowBoundaryOf,
    _opts$useOverlayAsCon = opts.useOverlayAsContainer,
    useOverlayAsContainer = _opts$useOverlayAsCon === void 0 ? false : _opts$useOverlayAsCon;
  var container = overlayNode instanceof HTMLElement ? getContainingBlock(overlayNode, useOverlayAsContainer) : document.documentElement;
  var isViewportContainer = container === document.documentElement;
  var containerPositionStyle = window.getComputedStyle(container).position;
  var isContainerPositioned = !!containerPositionStyle && containerPositionStyle !== 'static';
  var childOffset = isViewportContainer ? getOffset(targetNode) : getPosition(targetNode, container);
  if (!isViewportContainer) {
    var _window$getComputedSt = window.getComputedStyle(targetNode),
      marginTop = _window$getComputedSt.marginTop,
      marginLeft = _window$getComputedSt.marginLeft;
    childOffset.top += parseInt(marginTop, 10) || 0;
    childOffset.left += parseInt(marginLeft, 10) || 0;
  }
  var overlaySize = getOffset(overlayNode);
  var margins = getMargins(overlayNode);
  //@ts-expect-error
  overlaySize.width += margins.left + margins.right;
  //@ts-expect-error
  overlaySize.height += margins.top + margins.bottom;
  var scrollSize = getScroll(scrollNode);
  var boundaryDimensions = getContainerDimensions(boundaryElement);
  var containerDimensions = getContainerDimensions(container);
  // If the container is the HTML element wrapping the body element, the retrieved scrollTop/scrollLeft will be equal to the
  // body element's scroll. Set the container's scroll values to 0 since the overlay's edge position value in getDelta don't then need to be further offset
  // by the container scroll since they are essentially the same containing element and thus in the same coordinate system
  var containerOffsetWithBoundary = boundaryElement.tagName === 'BODY' ? getOffset(container) : getPosition(container, boundaryElement);
  if (container.tagName === 'HTML' && boundaryElement.tagName === 'BODY') {
    containerDimensions.scroll.top = 0;
    containerDimensions.scroll.left = 0;
  }
  return calculatePositionInternal(placement, childOffset, overlaySize, scrollSize, margins, padding, shouldFlip, boundaryDimensions, containerDimensions, containerOffsetWithBoundary, offset, crossOffset, isContainerPositioned, maxHeight, arrowSize, arrowBoundaryOffset);
}
function getOffset(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    top = _node$getBoundingClie.top,
    left = _node$getBoundingClie.left,
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  var _document$documentEle = document.documentElement,
    scrollTop = _document$documentEle.scrollTop,
    scrollLeft = _document$documentEle.scrollLeft,
    clientTop = _document$documentEle.clientTop,
    clientLeft = _document$documentEle.clientLeft;
  return {
    top: top + scrollTop - clientTop,
    left: left + scrollLeft - clientLeft,
    width: width,
    height: height
  };
}
function getPosition(node, parent) {
  var style = window.getComputedStyle(node);
  var offset;
  if (style.position === 'fixed') {
    var _node$getBoundingClie2 = node.getBoundingClientRect(),
      top = _node$getBoundingClie2.top,
      left = _node$getBoundingClie2.left,
      width = _node$getBoundingClie2.width,
      height = _node$getBoundingClie2.height;
    offset = {
      top: top,
      left: left,
      width: width,
      height: height
    };
  } else {
    offset = getOffset(node);
    var parentOffset = getOffset(parent);
    var parentStyle = window.getComputedStyle(parent);
    parentOffset.top += (parseInt(parentStyle.borderTopWidth, 10) || 0) - parent.scrollTop;
    parentOffset.left += (parseInt(parentStyle.borderLeftWidth, 10) || 0) - parent.scrollLeft;
    offset.top -= parentOffset.top;
    offset.left -= parentOffset.left;
  }
  offset.top -= parseInt(style.marginTop, 10) || 0;
  offset.left -= parseInt(style.marginLeft, 10) || 0;
  return offset;
}

// Returns the containing block of an element, which is the element that
// this element will be positioned relative to.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block
function getContainingBlock(node, useOverlayAsContainer) {
  // The offsetParent of an element in most cases equals the containing block.
  // https://w3c.github.io/csswg-drafts/cssom-view/#dom-htmlelement-offsetparent
  var offsetParent = node.offsetParent;
  // This is to bypass the isContainingBlock check which might fail depending on container
  // and prevents the wrong container from being chosen causing sizing issues.
  if (useOverlayAsContainer && !!offsetParent) return offsetParent;
  // The offsetParent algorithm terminates at the document body,
  // even if the body is not a containing block. Double check that
  // and use the documentElement if so.
  if (offsetParent && offsetParent === document.body && window.getComputedStyle(offsetParent).position === 'static' && !isContainingBlock(offsetParent)) {
    offsetParent = document.documentElement;
  }

  // TODO(later): handle table elements?

  // The offsetParent can be null if the element has position: fixed, or a few other cases.
  // We have to walk up the tree manually in this case because fixed positioned elements
  // are still positioned relative to their containing block, which is not always the viewport.
  if (offsetParent == null) {
    offsetParent = node.parentElement;
    while (offsetParent && !isContainingBlock(offsetParent)) {
      offsetParent = offsetParent.parentElement;
    }
  }

  // Fall back to the viewport.
  return offsetParent || document.documentElement;
}

// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function isContainingBlock(node) {
  var style = window.getComputedStyle(node);
  return style.transform !== 'none' || /transform|perspective/.test(style.willChange) || style.filter !== 'none' || style.contain === 'paint' ||
  // @ts-ignore
  'backdropFilter' in style && style.backdropFilter !== 'none' ||
  // @ts-ignore
  'WebkitBackdropFilter' in style && style.WebkitBackdropFilter !== 'none';
}

export { calculatePosition as default };
//# sourceMappingURL=calculate-position.esm.js.map
